import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import PropTypes from 'prop-types';
import React from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import { Date } from '@panneau/field-date';

var _excluded = ["name", "value", "options", "placeholder", "onChange", "className"];
var propTypes = {
  name: PropTypes.string,
  options: PropTypes$1.selectOptions,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string
};
var defaultProps = {
  name: 'radios',
  value: null,
  options: [],
  placeholder: null,
  className: null
};
var DateFilter = function DateFilter(_ref) {
  var name = _ref.name,
    value = _ref.value,
    options = _ref.options,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Date, Object.assign({}, props, {
    name: name,
    value: value,
    options: options,
    placeholder: placeholder,
    onChange: onChange
  })));
};
DateFilter.propTypes = propTypes;
DateFilter.defaultProps = defaultProps;

export { DateFilter as default };
